import { Document, Page, pdf, View, Text, Image, StyleSheet, Font } from '@react-pdf/renderer';
import logo from '@/assets/logo-patternx-color.png';
import PingFangSC from '@/assets/PingFang-SC.ttf';
// import project from '@/assets/project-administrator-select.png';
// import cloudModel from '@/assets/model-collaboration-slecte.png';
// import audit from '@/assets/audit.png';
// import digitalMarketing from '@/assets/digital-market-select.png';

type code = {
  code: string;
  createTime: string;
  _index: number;
};

type projectType = {
  code: projectCode;
  name: string;
};

interface CodePdfProps {
  codeList: code[];
  phone: string;
  authorize: string;
  cloud: string;
  project: projectType[];
  person: string;
  expiredDuration: number;
}
type projectCode =
  | 'project'
  | 'cloud_model'
  | 'audit_decision'
  | 'digital_marketing'
  | 'digital_marketing_pad';

const ptToPx = (pt: number) => pt / 2;
const styles = StyleSheet.create({
  page: {
    paddingBottom: ptToPx(40),
    paddingTop: ptToPx(40),
    paddingLeft: ptToPx(80),
    paddingRight: ptToPx(80),
    fontFamily: 'PingFang SC',
    position: 'relative',
  },
  topLine: {
    backgroundColor: '#5F4DFF',
    height: ptToPx(8),
    position: 'absolute',
    top: 0,
    width: '100vw',
  },
  logo: {
    width: ptToPx(135),
    height: ptToPx(36),
    marginBottom: ptToPx(32),
  },
  footLogo: {
    width: ptToPx(120),
    height: ptToPx(32),
    marginRight: ptToPx(40),
  },
  title: {
    fontSize: ptToPx(32),
    // lineHeight: '40px',
    fontWeight: 600,
    color: '#1D1D29',
  },
  subTitle: {
    fontWeight: 400,
    fontSize: ptToPx(14),
    color: '#5F6173',
  },
  info: {
    backgroundColor: '#F2F3F5',
    borderRadius: ptToPx(4),
    height: ptToPx(168),
    marginTop: ptToPx(12),
    padding: ptToPx(20),
  },
  infoItem: {
    marginBottom: ptToPx(8),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    // height:ptToPx(24),
  },
  infoItemLast: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  marginText: {
    fontWeight: 400,
    fontSize: ptToPx(14),
    color: '#1D1D29',
  },
  marginTextView: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  itemTitle: {
    fontWeight: 500,
    fontSize: ptToPx(14),
    color: '#868B9C',
    marginRight: ptToPx(12),
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    bottom: ptToPx(40),
    width: '100%',
  },
  footText: {
    fontSize: ptToPx(14),
    fontWeight: 400,
  },
  divider: {
    height: 1,
    backgroundColor: '#CACDD4',
    marginBottom: ptToPx(20),
  },
  tips: {
    marginTop: ptToPx(90),
  },
  tipTitle: {
    fontSize: ptToPx(16),
    fontWeight: 500,
    color: '#1D1D29',
    marginBottom: ptToPx(12),
  },
  tipContent: {
    fontSize: ptToPx(14),
    fontWeight: 400,
    color: '#5F6173',
  },
  codeArea: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: ptToPx(20),
  },
  codeRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    // marginRight: ptToPx(80),
    position: 'relative',
    width: '25%',
  },
  codeItem: {
    // width: ptToPx(152),
    // maxWidth:ptToPx(170),
    // minWidth:ptToPx(143),
    height: ptToPx(44),
    paddingTop: ptToPx(8),
    paddingBottom: ptToPx(8),
    paddingLeft: ptToPx(12),
    paddingRight: ptToPx(12),
    backgroundColor: 'rgba(225, 227, 232, 0.4)',
    borderRadius: ptToPx(2),
    fontSize: ptToPx(20),
    fontWeight: 500,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  codeIndex: {
    fontSize: ptToPx(16),
    color: '#868B9C',
    width: ptToPx(18),
    textAlign: 'right',
    marginRight: ptToPx(12),
  },
  project: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    // marginRight: ptToPx(24),
    // height: ptToPx(24)
  },
  projectImg: {
    width: ptToPx(24),
    height: ptToPx(24),
    marginRight: ptToPx(10),
    marginTop: ptToPx(-7),
  },
  projectText: {
    fontSize: ptToPx(14),
    fontWeight: 400,
    color: '#1D1D29',
  },
});

Font.register({ family: 'PingFang SC', src: PingFangSC });

const groupBy = <T extends any>(arr: T[], dept: number) => {
  const tmp: Array<Array<T>> = [];
  for (let i = 0; i < arr.length; i += dept) {
    tmp.push([...(arr.slice(i, i + dept) as T[])]);
  }
  return tmp;
};
const CodePdf = (codePdfProps: CodePdfProps) => {
  const { codeList } = codePdfProps;
  const _codeList = groupBy<code>(codeList, 60);
  const projectInfo = (type: projectType, hasComma: boolean) => {
    // let template = { src: '', text: '' };
    // switch (type.code) {
    //     case 'project': {
    //         template = { src: project, text: '项目管理' };
    //         break;
    //     }
    //     case 'cloud_model': {
    //         template = { src: cloudModel, text: '模型协同' };
    //         break;
    //     }
    //     case 'audit_decision': {
    //         template = { src: audit, text: '审核决策' };
    //         break;
    //     }
    //     case 'digital_marketing': {
    //         template = { src: digitalMarketing, text: '数字营销' };
    //         break;
    //     }
    //     case 'digital_marketing_pad': {
    //         template = { src: digitalMarketing, text: '数字营销Pad端' };
    //     }
    // }

    return (
      <View style={styles.project} key={type.code}>
        {/* <Image src={template.src} style={styles.projectImg} /> */}
        <Text style={styles.projectText}>
          {type.name}
          {hasComma ? '、' : ''}
        </Text>
      </View>
    );
  };
  const headerInfo = () => (
    <>
      <Image src={logo} style={styles.logo} />
      <Text style={styles.title}>天云筑电子授权码信息</Text>
      <Text style={styles.subTitle}>
        感谢您使用天云筑的服务，请基于如下授权信息使用我们的服务。
      </Text>
      <View style={styles.info}>
        <View style={styles.infoItem} key="auth">
          <Text style={styles.itemTitle}>授权方</Text>
          <Text style={styles.marginText}>{codePdfProps.authorize}</Text>
        </View>
        <View style={styles.infoItem} key="cloud">
          <Text style={styles.itemTitle}>企业云空间</Text>
          <Text style={styles.marginText}>{codePdfProps.cloud}</Text>
        </View>
        <View style={styles.infoItem} key="person">
          <Text style={styles.itemTitle}>联系人</Text>
          <Text style={styles.marginText}>{codePdfProps.person}</Text>
        </View>
        <View style={styles.infoItem} key="phone">
          <Text style={styles.itemTitle}>联系电话</Text>
          <Text style={styles.marginText}>{codePdfProps.phone}</Text>
        </View>
        <View style={styles.infoItemLast} key="info">
          <Text style={styles.itemTitle}>产品模块信息</Text>
          <View style={styles.marginTextView}>
            {codePdfProps.project?.map((item, index: number) =>
              projectInfo(item, index < codePdfProps.project.length - 1),
            )}
          </View>
        </View>
      </View>
    </>
  );

  const envUrl = () => {
    return window.location.host.replace('boss', 'standard');
  };

  const tips = () => (
    <View style={styles.tips}>
      <View style={styles.divider}></View>
      <Text style={styles.tipTitle} key="a">
        项目授权码使用说明
      </Text>
      <Text style={styles.tipContent} key="b">
        1、登录{envUrl()}
        ，创建项目，输入以上任一项目授权码信息，即可成功激活项目空间并使用我们给您提供的产品和服务。
      </Text>
      <Text style={styles.tipContent} key="c">
        {`2、天云筑项目空间使用期限按合同约定（${codePdfProps.expiredDuration}个月），自成功创建项目空间之日起算；超过使用期限，如需继续使用需要重新续费。`}
      </Text>
    </View>
  );
  const CodeTemplate = () => (
    <Document>
      {_codeList.map((page, pageIndex) => (
        <Page size="A4" style={styles.page} wrap key={pageIndex}>
          <View style={styles.topLine} key={'x0'}></View>
          {pageIndex === 0 && headerInfo()}

          <View style={{ marginTop: ptToPx(40) }} key={'x1'}>
            {groupBy(page, 4).map((item, index) => (
              <View style={styles.codeArea} key={index}>
                {item.map((it, index2: number) => (
                  <View style={styles.codeRow} key={index2}>
                    <Text style={styles.codeIndex}>{it._index + 1}</Text>
                    <View style={styles.codeItem}>
                      <Text>{it.code}</Text>
                    </View>
                  </View>
                ))}
              </View>
            ))}
          </View>
          {pageIndex === _codeList.length - 1 && tips()}

          <View style={styles.footer}>
            <Image src={logo} style={styles.footLogo}></Image>
            <View>
              <Text style={styles.footText}>
                <Text style={{ color: '#868B9C' }}>公司地址：</Text>
                广东省深圳市福田区瀚森大厦1101-1
              </Text>
              <Text style={styles.footText}>
                <Text style={{ color: '#868B9C' }}>联系方式：</Text>
                tiangongyun@patternx.gemdale.com
              </Text>
              <Text style={styles.footText}>
                <Text style={{ color: '#868B9C' }}>联系电话：</Text>
                0755-82736501
              </Text>
            </View>
          </View>
        </Page>
      ))}
    </Document>
  );
  return CodeTemplate();
};

const downLoadPdf = (props: CodePdfProps) => {
  return pdf(CodePdf(props)).toBlob();
};

export { downLoadPdf };
